export default {
  GET_SEARCH_DATA: 'ott/railways/getSearchData',
  GET_SEARCH_DATA_SUCCESS: 'ott/railways/getSearchDataSuccess',
  GET_SEARCH_DATA_FAIL: 'ott/railways/getSearchDataFail',
  GET_SEARCH_DATA_RESET: 'ott/railways/getSearchDataReset',
};
